import { render, staticRenderFns } from "./ModalFaqs.vue?vue&type=template&id=5f67c9c3"
import script from "./ModalFaqs.vue?vue&type=script&lang=js"
export * from "./ModalFaqs.vue?vue&type=script&lang=js"
import style0 from "./ModalFaqs.vue?vue&type=style&index=0&id=5f67c9c3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports